import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Reservation } from '../../interfaces/reservation';
import { ReservationsService } from '../../services/reservations.service';
import { QrmodalComponent } from '../qrmodal/qrmodal.component';
import { Router, RouterModule } from '@angular/router';
import { ReservationCardComponent } from "../reservation-card/reservation-card.component";
import { ButtonComponent } from '../button/button.component';
import { SkeletonComponent } from '../skeleton/skeleton.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-reservations',
  standalone: true,
  imports: [CommonModule, RouterModule, ReservationCardComponent, ButtonComponent, SkeletonComponent, TranslateModule],
  templateUrl: './reservations.component.html',
  styleUrls: ['./reservations.component.scss']
})
export class ReservationsComponent {
  pastReservations: Reservation[] = [];
  futureReservations: Reservation[] = [];
  isLoadingFutureReservations: boolean = true;
  isLoadingPastReservations: boolean = true;
  
  constructor(private reservationsService: ReservationsService, private dialog: MatDialog, private router: Router) {}

  ngOnInit() {
    this.fetchReservations();
  }
  fetchReservations() {
    this.reservationsService.getReservations().subscribe(
      (reservations) => {
        // this.pastReservations = reservations.pastReservations
        // this.futureReservations = reservations.futureReservations


        this.futureReservations = reservations.futureReservations.filter(
          reservation => reservation.statusId === 2
        );
        this.isLoadingFutureReservations = false;
        
        this.pastReservations = reservations.pastReservations.filter(
          reservation => reservation.statusId === 2
        );
        this.isLoadingPastReservations = false;

        // const today = new Date();        
        // this.reservations = reservations;
  
        // // Ordenar reservas por createdAt (más nuevas primero)
        // this.reservations.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  
        // // Filtrar y ordenar reservas futuras o de hoy
        // this.upcomingReservations = this.reservations
        //   .filter(reservation => {
        //     const reservationDate = new Date(reservation.event.date);
        //     return reservationDate >= new Date(today.setHours(0, 0, 0, 0)); // Hoy o en el futuro
        //   })
        //   .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()); // Cambiado el orden aquí
  
        // // Filtrar y ordenar reservas pasadas
        // this.pastReservations = this.reservations
        //   .filter(reservation => {
        //     const reservationDate = new Date(reservation.event.date);
        //     return reservationDate < new Date(today.setHours(0, 0, 0, 0)); // Fechas pasadas
        //   })
        //   .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()); // Cambiado el orden aquí
      },
      (error) => {
        console.error('Error fetching reservations:', error);
        this.isLoadingFutureReservations = false;
        this.isLoadingPastReservations = false;
      }
    );
  }

  goToReservation(reservation: Reservation){
    this.router.navigate(['reservation', reservation.locator])
  }

  goToEvents() {
    this.router.navigate([''], { fragment: 'eventos' });
  }
}
